import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

/** Entrada alternativa em `/login-interno-kc`: login Keycloak nativo (sem IdP Gov.BR), mesmo com `idpHint: gov-br`. */
@Component({
  selector: 'app-interno-kc-login',
  standalone: true,
  template: '<p class="redirect-msg">Redirecionando para autenticação...</p>',
  styles: [
    `
      .redirect-msg {
        margin: 2rem auto;
        max-width: 24rem;
        text-align: center;
        color: #636363;
      }
    `,
  ],
})
export class InternoKcLoginComponent implements OnInit {
  private auth = inject(AuthService);
  private router = inject(Router);

  ngOnInit(): void {
    if (this.auth.isAuthenticated()) {
      void this.router.navigate(['/']);
      return;
    }
    void this.auth.loginRedirect({ skipIdpHint: true });
  }
}
